export const meta = {
  title: 'Pengebilan & langganan anda',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'staff'],
};

Segala tentang apa yang anda bayar berada di halaman **Pengebilan** papan pemuka anda: pelan anda, status percubaan, tarikh pengebilan seterusnya, bilangan outlet yang dikenakan caj, dan setiap invois yang pernah dikeluarkan. Tiada caj misteri — setiap perubahan direkodkan dalam log audit yang boleh anda baca.

## Tempoh percubaan

Akaun anda bermula dengan **percubaan percuma 14 hari** dengan akses penuh — tiada kad direkodkan, tiada apa yang dicaj. Halaman Pengebilan menunjukkan dengan tepat berapa hari percubaan yang tinggal. Batalkan semasa percubaan dan anda tidak berhutang apa-apa.

## Bagaimana invois bulanan berfungsi

Pengebilan berjalan **selepas penggunaan**: tidak lama selepas tengah malam pada 1 haribulan setiap bulan, satu invois dikeluarkan merangkumi bulan yang baru berakhir. Ia memperincikan pelan anda, sebarang outlet tambahan, dan sebarang perubahan pro-rata yang anda buat pertengahan bulan — jadi jumlahnya tidak pernah mengejutkan.

## Membayar invois

Setiap invois terbuka di halaman Pengebilan ada butang **Bayar sekarang**. Ia membuka halaman pembayaran FPX yang selamat — bayar terus daripada mana-mana akaun bank Malaysia. Sebaik bank mengesahkan, invois bertukar kepada _dibayar_ secara automatik, biasanya dalam beberapa saat.

Jika pautan pembayaran sudah luput, gunakan tindakan segar semula di sebelah invois untuk mengeluarkan pautan baharu. Ambil perhatian: hanya pautan **terbaru** bagi sesuatu invois boleh menyelesaikannya — pautan lama ditolak untuk mengelakkan caj berganda.

## Menambah outlet

Tambah outlet dari halaman **Outlet**. Sebelum anda sahkan, anda melihat pratonton langsung caj pro-rata — anda hanya membayar untuk baki hari dalam bulan semasa, dan jumlah itu masuk ke invois anda yang seterusnya. Outlet baharu boleh terus digunakan, dengan giliran dan kod QR sendiri.

## Membuang outlet

Pembuangan outlet berkuat kuasa pada **hujung bulan**. Ia terus berfungsi sehingga itu — anda sudah pun membayar untuk hari-hari tersebut — dan hanya digugurkan daripada invois seterusnya. Halaman Pengebilan menyenaraikan pembuangan tertunda dengan tarikh kuat kuasanya, jadi tiada teka-teki.

## SST dan invois cukai

Jika perniagaan anda berdaftar SST, buka kad cukai di halaman Pengebilan (pemilik sahaja), aktifkannya, dan masukkan nombor SST serta butiran entiti perniagaan anda. Setiap invois selepas itu membawa baris SST dan PDF-nya dijana sebagai invois cukai yang sah.

## PDF invois

Setiap invois ada butang **PDF** — muat turun untuk akauntan anda atau simpanan anda. Invois yang dibayar menunjukkan bila dan bagaimana ia diselesaikan.

## Jejak audit

Halaman Pengebilan diakhiri dengan lejar **peristiwa langganan** anda: setiap perubahan pelan, penambahan outlet, pembuangan, dan caj — semuanya bertarikh. Jika ada angka pada invois yang kelihatan asing, lejar ini memberitahu anda dari mana ia datang.
